var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('page', [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading.dashboard,
      expression: "loading.dashboard"
    }],
    staticClass: "filters desktop"
  }, [_c('el-form', {
    attrs: {
      "inline": "",
      "size": "small"
    }
  }, [_c('el-form-item', [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "unlink-panels": "",
      "clearable": "",
      "start-placeholder": "Start date",
      "end-placeholder": "End date",
      "format": _vm.dateRangeFormat,
      "picker-options": _vm.datePickerOptions
    },
    model: {
      value: _vm.datesRange,
      callback: function ($$v) {
        _vm.datesRange = $$v;
      },
      expression: "datesRange"
    }
  })], 1), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "Period"
    },
    model: {
      value: _vm.period,
      callback: function ($$v) {
        _vm.period = $$v;
      },
      expression: "period"
    }
  }, _vm._l(_vm.dashboardPeriodOptions, function (p) {
    return _c('el-option', {
      key: p.value,
      attrs: {
        "label": p.label,
        "value": p.value
      }
    });
  }), 1)], 1)], 1), _c('div', [_c('el-button', {
    attrs: {
      "round": "",
      "icon": "el-icon-s-tools",
      "size": "small"
    },
    on: {
      "click": function () {
        return _vm.showManageReportsDialog = true;
      }
    }
  }, [_vm._v("Manage Dashboard")])], 1)], 1), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading.dashboard,
      expression: "loading.dashboard"
    }],
    staticClass: "filters mobile"
  }, [_c('div', [_vm._v("Filter results for the past:")]), _c('div', [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function ($event) {
        return _vm.updateResults(14, 'days', 'day');
      }
    }
  }, [_vm._v("14 days")]), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function ($event) {
        return _vm.updateResults(30, 'days', 'week');
      }
    }
  }, [_vm._v("30 days")]), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function ($event) {
        return _vm.updateResults(6, 'months', 'month');
      }
    }
  }, [_vm._v("6 months")])], 1)]), _vm.dashboard.reports && !_vm.dashboard.reports.length ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(" it seems like you don't follow any report... click on Manage dashboard in order to add some. ")]) : _vm._e(), _vm._l(_vm.dashboard.reports, function (report, index) {
    return _c('div', {
      key: index
    }, [_c('report-chart', {
      attrs: {
        "report": report,
        "params": _vm.chartParams
      }
    })], 1);
  }), _c('manage-reports', {
    attrs: {
      "isOpen": _vm.showManageReportsDialog,
      "onClose": function () {
        return _vm.showManageReportsDialog = false;
      }
    }
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }